export default {
    pinCodeDisplay: {
        dataTrackId: 'pin-code-display',
        dataTrackLinkname: 'pin-kode',
    },
    newPinEntry: {
        dataTrackId: 'new-pin-entry',
        dataTrackLinkname: 'skriv inn ny pin',
    },
};
